import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OutcomeProgress = {
  id: string;
  tempId?: string;
  date: string;
  progressDescription: string;
  progressRating: string;
};

type Outcome = {
  id: string;
  tempId?: string;
  concernPriority: string | null;
  outcome: string | null;
  measurableCriteriaProcedures: string | null;
  timeFrame: string | null;
  startDate: string | null;
  endDate: string | null;
  tbrOutcomeId: number;
  tbrUpdateRequired: boolean;
  outcomeProgressList: OutcomeProgress[];
};

export type ChildAndFamilOutcomesType = {
  ifspId: string;
  outcome: Outcome[];
  isCurrentlyHeld: boolean;
  heldBy: string | null;
  displayBanner: boolean;
};

export type InitialChildAndFamilOutcomesType = {
  ifspId: string;
  outcome: Outcome[];
  originalOutcome: Outcome[];
  displayBanner: boolean;
  isCurrentlyHeld: boolean;
  heldBy: string | null;
};

const initialChildAndOutcomesIFSPData: InitialChildAndFamilOutcomesType = {
  ifspId: '',
  isCurrentlyHeld: false,
  heldBy: null,
  displayBanner: false,
  outcome: [
    {
      id: '',
      tempId: '',
      concernPriority: '',
      outcome: '',
      measurableCriteriaProcedures: '',
      timeFrame: '',
      startDate: '',
      endDate: '',
      tbrOutcomeId: 0,
      tbrUpdateRequired: false,
      outcomeProgressList: [
        {
          id: '',
          date: '',
          progressDescription: '',
          progressRating: '',
        },
      ],
    },
  ],
  originalOutcome: [
    {
      id: '',
      tempId: '',
      concernPriority: '',
      outcome: '',
      measurableCriteriaProcedures: '',
      timeFrame: '',
      startDate: '',
      endDate: '',
      tbrOutcomeId: 0,
      tbrUpdateRequired: false,
      outcomeProgressList: [
        {
          id: '',
          date: '',
          progressDescription: '',
          progressRating: '',
        },
      ],
    },
  ],
};

const ifspOutcomesSlice = createSlice({
  name: 'ifspOutcomes',
  initialState: initialChildAndOutcomesIFSPData,
  reducers: {
    setIfspOutcomes: (
      state,
      action: PayloadAction<ChildAndFamilOutcomesType>,
    ) => {
      state.ifspId = action.payload.ifspId;
      state.outcome = action.payload.outcome;
      state.originalOutcome = action.payload.outcome;
      state.isCurrentlyHeld = action.payload.isCurrentlyHeld;
      state.heldBy = action.payload.heldBy;
      state.displayBanner = action.payload.displayBanner;
    },
    updateIfspOutcomes: (
      state,
      action: PayloadAction<Partial<ChildAndFamilOutcomesType>>,
    ) => {
      state.outcome = action.payload.outcome || [];
    },
    updateOriginalOutcomes: (state, action) => {
      state.originalOutcome = action.payload.outcome || [];
    },
    resetIfspOutcomes: () => {
      return initialChildAndOutcomesIFSPData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialChildAndOutcomesIFSPData,
    );
  },
});

export const {
  setIfspOutcomes,
  updateIfspOutcomes,
  updateOriginalOutcomes,
  resetIfspOutcomes,
} = ifspOutcomesSlice.actions;
export default ifspOutcomesSlice.reducer;
